<template>
  <b-navbar variant="white" type="light" toggleable="lg" class="sticky">
    <b-navbar-brand class="brand-nav bg-transparent" to="/">
      <img width="70" height="48" src="@app/images/logo-blue.svg" alt />
    </b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="m-auto">
        <b-nav-item
          class="text-uppercase text-center pt-main item-nav"
          href="/"
        >
          Главная
        </b-nav-item>
        <b-nav-item-dropdown
          text="Модули"
          class="text-uppercase text-center pt-main item-nav"
        >
          <b-dropdown-item
            class="text-uppercase text-center pt-main item-nav"
            to="/chat"
          >
            {{ trans('layout.chat') }}
          </b-dropdown-item>
          <b-dropdown-item
            class="text-uppercase text-center pt-main item-nav"
            to="/formbuilder"
          >
            {{ trans('layout.formbuilder') }}
          </b-dropdown-item>
          <b-dropdown-item
            class="text-uppercase text-center pt-main item-nav"
            to="/registry"
          >
            Регистратура
          </b-dropdown-item>
          <b-dropdown-item
            class="text-uppercase text-center pt-main item-nav"
            v-if="hasPermission('admin.index')"
            href="/admin"
          >
            {{ trans('layout.admin') }}
          </b-dropdown-item>
          <b-dropdown-item
            class="text-uppercase text-center pt-main item-nav"
            href="/dictionaries"
          >
            {{ trans('layout.dictionaries') }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item
          class="text-uppercase text-center pt-main item-nav"
          to="/clinics"
        >
          Клиники
        </b-nav-item>

        <b-nav-item to="/contacts" class="pt-main item-nav text-center">
          КОНТАКТЫ
        </b-nav-item>
        <b-nav-item
          v-if="!auth_user"
          class="pt-main text-center"
          dusk="show-login-form"
          @click="$bvModal.show('bv-modal-login')"
        >
          ВХОД
        </b-nav-item>
        <template v-else>
          <b-nav-item-dropdown class="pl-2 text-center">
            <template v-slot:button-content>
              <em class="text-uppercase color-name-link">
                {{ getAuthUserFullName }}
                <img
                  class="main-page-avatar"
                  src="@app/images/avatar.png"
                  alt="user"
                />
              </em>
            </template>
            <router-link
              v-if="auth_user && routeIsClinic"
              tag="b-dropdown-item"
              :to="{ name: 'personal-area.main' }"
            >
              Личный кабинет
            </router-link>
            <router-link tag="b-dropdown-item" to="/profilepage">
              Профиль
            </router-link>
            <b-dropdown-item @click="logout()">
              {{ trans('auth.logout') }}
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </template>
        <b-nav-item class="pt-main text-center">
          <b-button class="btn-tel rounded">+7-982-996-67-36</b-button>
        </b-nav-item>
        <b-modal id="bv-modal-login" hide-footer>
          <template v-slot:modal-title>Вход</template>
          <div class="d-block text-center">
            <form
              class="form-horizontal form-material"
              id="loginform"
              @submit.prevent="submit"
              @keydown="loginForm.errors.clear($event.target.name)"
            >
              <h3 class="box-title m-b-20">{{ trans('auth.login') }}</h3>
              <div class="form-group">
                <input
                  type="text"
                  name="email"
                  class="form-control"
                  :placeholder="trans('auth.email')"
                  v-model="loginForm.email"
                />
                <show-error
                  :form-name="loginForm"
                  prop-name="email"
                ></show-error>
              </div>
              <div class="form-group">
                <input
                  type="password"
                  name="password"
                  class="form-control"
                  :placeholder="trans('auth.password')"
                  v-model="loginForm.password"
                />
                <show-error
                  :form-name="loginForm"
                  prop-name="password"
                ></show-error>
              </div>
              <div
                class="g-recaptcha"
                v-if="getConfig('recaptcha') && getConfig('login_recaptcha')"
                :data-sitekey="getConfig('recaptcha_key')"
              ></div>
              <div class="form-group text-center m-t-20">
                <button
                  class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                  type="submit"
                >
                  {{ trans('auth.sign_in') }}
                </button>
              </div>
              <div class="form-group m-b-0">
                <div class="col-sm-12 text-center">
                  <!-- <p v-if="getConfig('reset_password')">{{trans('auth.forgot_your_password?')}} <router-link to="/password" class="text-info m-l-5"><b>{{trans('auth.reset_here!')}}</b></router-link></p>
                  <p v-if="getConfig('registration')">{{trans('auth.create_account?')}} <router-link to="/register" class="text-info m-l-5"><b>{{trans('auth.sign_up')}}</b></router-link></p>-->
                  <p>
                    {{ trans('auth.forgot_your_password?') }}
                    <router-link to="/password" class="text-info m-l-5">
                      <b>{{ trans('auth.reset_here!') }}</b>
                    </router-link>
                  </p>
                  <p>
                    {{ trans('auth.create_account?') }}
                    <router-link to="/register" class="text-info m-l-5">
                      <b>{{ trans('auth.sign_up') }}</b>
                    </router-link>
                  </p>
                </div>
              </div>
              <div class="row" v-if="getConfig('social_login')">
                <div class="col-12 col-sm-12 m-t-10 text-center">
                  <div class="social" v-if="getConfig(provider + '_login')">
                    <a
                      v-for="provider in social_login_providers"
                      :key="provider"
                      :href="`/auth/social/${provider}`"
                      :class="['btn', 'btn-' + provider, 'm-r-5', 'no-hover']"
                      v-tooltip="trans('auth.login_with', { type: provider })"
                    >
                      <i :class="['fab', 'fa-' + provider]"></i>
                    </a>
                  </div>
                </div>
              </div>
              <!-- <div class="row m-t-10" v-if="!getConfig('mode')">
                <div class="col-6 text-center">
                  <button type="button" class="btn bt-block btn-info" @click="loginAsAdmin">Login as Admin</button>
                </div>
                <div class="col-6 text-center">
                  <button type="button" class="btn bt-block btn-success" @click="loginAsUser">Login as User</button>
                </div>
              </div>-->
            </form>
          </div>
        </b-modal>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
/*global Form*/
/*eslint no-undef: "error"*/

export default {
  data() {
    return {
      user: this.$store.state.auth.user,
      auth_user: this.$store.state.auth.is_auth,
      loginForm: new Form({
        username: '',
        password: '',
        client_id: '',
        client_secret: ''
      }),
      social_login_providers: []
    };
  },
  mounted() {
    if (helper.getConfig('social_login')) {
      axios
        .get('/api/configuration/variable?type=social_login')
        .then(response => response.data)
        .then(response => {
          this.social_login_providers = response.social_login_providers;
        })
        .catch(error => {
          helper.showDataErrorMsg(error);
        });
    }
    var page = this.$store.state.auth.previousPage;
    if (page && page.path !== '/') {
      if (helper.isAuth()) {
        this.$router.push(page);
        this.$store.commit('auth/setPreviousPage', null);
      }
    }
  },
  methods: {
    loginAsAdmin() {},
    loginAsUser() {},
    hasPermission(permission) {
      return helper.hasPermission(permission);
    },
    getAuthUser(name) {
      return helper.getAuthUser(name);
    },
    logout() {
      // this.$store.dispatch('auth/resetAuthUserDetail');
      // document.location.href = '/logout'
      helper.logout().then(() => {
        this.$store.dispatch('auth/resetAuthUserDetail');
        document.location.href = '/';
      });
    },
    submit() {
      var page = this.$store.state.auth.previousPage;
      if (page && page.path !== '/') {
        this.loginForm.redirectPage = page.path;
      }
      this.loginForm
        .post('/oauth/token')
        .then(response => {
          localStorage.setItem('auth_token', response.token);
          axios.defaults.headers.common['Authorization'] =
            'Bearer ' + localStorage.getItem('auth_token');
          this.$store.dispatch('auth/setAuthStatus');
          this.$store.dispatch('auth/setLastActivity');
          toastr.success(response.message);
          this.$bvModal.hide('bv-modal-login');
          location.reload();

          if (
            helper.getConfig('two_factor_security') &&
            response.two_factor_code
          ) {
            this.$store.dispatch(
              'auth/setTwoFactorCode',
              response.two_factor_code
            );
            this.$router.push('/auth/security');
            this.$bvModal.hide('bv-modal-login');
          } else {
            var redirect_path = this.$route.query.redirect || '/';
            this.$store.dispatch('auth/resetTwoFactorCode');
            this.$router.push({
              path: redirect_path,
              query: response.reload ? { reload: 1 } : null
            });
            this.$bvModal.hide('bv-modal-login');
          }
        })
        .catch(error => {
          helper.showErrorMsg(error);
        });
    },
    getConfig(config) {
      return helper.getConfig(config);
    }
  },
  computed: {
    //username: `${this.user.last_name} ${this.user.first_name} ${this.user.middle_name}`,
    routeIsClinic() {
      console.log(this.$route.matched);
      return (
        this.$route.matched.length > 1 &&
        this.$route.matched[1].name === 'clinics'
      );
    },
    getAuthUserFullName() {
      return this.$store.getters['auth/getAuthUserFullName'];
    }
  }
};
</script>

<style lang="sass" scoped>
.main_content
  min-height: 54.3vh
.h-50p
  height: 50px
.color-footer-item
  color: #fff !important
  margin-left: 3rem !important
.bg-color-footer-item
  background-color: white !important

.btn-tel
  background-color: #392d9e
  border: 2px solid white

.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle
  background-color: #a73479
  border-color: white

.sticky
  position: fixed
  box-shadow: 0 5px 10px 5px rgba(0,0,0,.05)
  z-index: 1001
  width: 100%

.brand-nav
  padding: 0.5rem
  color: #041128

.bg-secondary
  background-color: #bec3c7 !important

.bg-secondary_2
  background-color: #e7e9ea

@media (max-width: 1099px) and (min-width: 850px)
  .nav-item.text-uppercase
    padding-right: 0 !important
@media (max-width: 1024px)
  .brand-nav
    display: none
.main-page-avatar
  width: 40px
  margin-left: 1rem
  border: 1px solid #041128
  border-radius: 50%

.pt-main
  padding-top: 0.40rem

.color-first-header-item
  color: #29abe2

.bg-color-first-header-item
  background-color: #29abe2 !important
.link-module
  text-decoration: none

@media (max-width: 1023px)
  .first-nav
    padding-top: 0 !important

  a.nav-link
    padding: 0 !important

@media (max-width:500px)
  .h-50p
    height: 100px
@media (max-width: 1000px)
  .sticky
    width: 100%
@media (max-width: 767px)
  .color-footer-item
    margin-left: 0 !important
  .list-unstyled
    padding-left: 0rem !important

a.nav-link
  color: #041128 !important

.color-name-link
  color: #041128

.item-nav-active
  background-color: #29abe2

.item-nav-active a.nav-link
  color: white !important
</style>
